import React from 'react';
import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'components';
import Button from 'components/button';

const InvalidModal = ({
  custom = false,
  isVisible,
  setVisible,
  rejectReasons,
  error,
  returnButtonTitle,
  returnButtonNavigate,
}) => {
  const navigate = useNavigate();

  const returnButtonActions = () => {
    setVisible(false);
    navigate(`${returnButtonNavigate}`);
  };
  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      onCancel={() => setVisible(false)}
      width={400}
      footer={
        returnButtonTitle && [
          <Button
            label={returnButtonTitle}
            type={'default'}
            onClick={returnButtonActions}
          />,
        ]
      }
      className={'invalid-modal'}
    >
      {error?.systemCode === 'ONBOARDING' && (
        <>
          <div className=" mt-2 invalid-modal__header">
            {error?.businessCode === '100' &&
              <h2>Αδυναμία Δημιουργίας Αίτησης</h2>
            }
            {error?.businessCode === '107' &&
              <h2>Αδυναμία Αξιολόγησης Αίτησης</h2>
            }
            {error?.businessCode === '110' &&
              <h2>Αδυναμία Αξιολόγησης Αίτησης</h2>
            }
          </div>
          <div className="invalid-modal__body">
            {error?.businessCode === '100' && (
              //  <p>{error?.message}</p>
              <p>Βρέθηκε δήλωση ενδιαφέροντος για το ίδιο ΑΦΜ.</p>
            )}
            {error?.businessCode === '107' && (
               <p>{error?.message}</p>
              // <p>Βρέθηκε δήλωση ενδιαφέροντος για το ίδιο ΑΦΜ.</p>
            )}
            {error?.businessCode === '110' && (
              //  <p>{error?.message}</p>
              <p>Η αίτηση έχει ήδη αξιολογηθεί.</p>
            )}
          </div>
        </>
      )}
      {custom && error && (
        <>
          <div className="invalid-modal__body mt-2">
            <p>{error}</p>
          </div>
        </>
      )}
      {/* {rejectReasons.case === "checkUniqueness" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Δημιουργίας Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            {rejectReasons.responseCode === "901" &&
             <p>Η δημιουργία αίτησης δεν είναι εφικτή καθώς υπάρχει ενεργή αίτηση με το ίδιο ΑΦΜ.</p>}
          </div>
        </>
      }
      {rejectReasons.case === "thirdPartyValidations" && 
        <>
          <div className=" mt-2 invalid-modal__header">
            <h2>Αδυναμία Υποβολής Αίτησης</h2>
          </div>
          <div className="invalid-modal__body">
            <h4>Η αίτησή σας απορρίφθηκε, καθώς:</h4>
            {!rejectReasons.isGreekAfm && <p>δεν είναι Ελληνικό Α.Φ.Μ.</p> }
            {!rejectReasons.isActive && <p>δεν είναι ενεργή κατά την ημερομηνία υποβολής της αίτησης Χρηματοδότησης από το Πρόγραμμα.</p> }
            {rejectReasons.responseCode === "901" && <p>υπάρχει ήδη ενεργή αίτηση με αυτό το ΑΦΜ.</p>}
            {rejectReasons.responseCode === "902" && <p>έχετε ήδη λάβει επιδότηση μέσω της δράσης Super-FastBroadband (SFBB).</p>}
            {rejectReasons.responseCode === "903" && <p>το αίτημα δεν είναι αποδεκτό λόγω μη επιλέξιμου ΚΑΔ.</p>}
            {rejectReasons.responseCode === "904" && <p>ο ΑΦΜ έχει υπερβεί το όριο κρατικών ενισχύσεων μέσω του προγράμματος «Smart Readiness»</p>}
          </div>
        </>
      } */}
    </Modal>
  );
};

export default InvalidModal;
